const transformToUpdateAllergenIncludedAllergensDetailsArgs = data =>
  data?.allergenIncludedAllergenIds

export default transformToUpdateAllergenIncludedAllergensDetailsArgs
